import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Alert, Button, Container, Stack } from '../design-system';
import { Typography } from '@mui/material';
import { acceptSubscriptionInvitation } from '../services/teamManagementService';
import { useAuth } from '../context/AuthContext';

export default function AcceptInvitationPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { refreshAuthorization } = useAuth();
  const [error, setError] = useState('');
  const [accepting, setAccepting] = useState(false);
  const [invitationAccepted, setInvitationAccepted] = useState(false);
  useEffect(() => { if (!token) setError('La invitación no es válida.'); }, [token]);
  const accept = async () => {
    setAccepting(true);
    setError('');
    let accepted = invitationAccepted;
    try {
      if (!accepted) {
        await acceptSubscriptionInvitation(token);
        accepted = true;
        setInvitationAccepted(true);
      }
      await refreshAuthorization();
      navigate('/administrar-equipos', { replace: true });
    } catch (acceptError) {
      setError(
        accepted
          ? `La invitación se aceptó, pero no se pudieron actualizar los permisos: ${acceptError.message || 'recarga la página.'}`
          : acceptError.message || 'No se pudo aceptar la invitación.'
      );
    }
    finally { setAccepting(false); }
  };
  return <Container className="wp-page" maxWidth="sm" sx={{ py: 8 }}><Stack spacing={3} alignItems="flex-start">
    <Typography component="h1" variant="h4" fontWeight={800}>Invitación al equipo</Typography>
    <Typography color="text.secondary">Acepta la invitación con la misma dirección de email a la que fue enviada.</Typography>
    {error && <Alert severity="error">{error}</Alert>}
    <Button variant="contained" onClick={accept} disabled={accepting || (!token && Boolean(error))}>
      {accepting ? 'Aceptando...' : invitationAccepted ? 'Reintentar actualización' : 'Aceptar invitación'}
    </Button>
  </Stack></Container>;
}
